"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StudentQRCodeLogin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _studentLoginBg = _interopRequireDefault(require("../assets/student-login-bg.png"));
var _teacherQrcodeHelp = _interopRequireDefault(require("../assets/teacher-qrcode-help.png"));
require("./styles.scss");
var _QRcodeInput = require("./QRcodeInput");
var _state = require("../state");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var StudentQRCodeLogin = function StudentQRCodeLogin() {
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    showQRPopup = _useAuthSigninState.showQRPopup,
    getFromPage = _useAuthSigninState.getFromPage;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    hasCameraAccess = _useState2[0],
    setHasCameraAccess = _useState2[1];
  (0, _react.useEffect)(function () {
    if (window.location.hash.includes('student-qrcode')) {
      trackEventsForGuests("Viewed QR Code Input Screen", {
        "mp_login_user_type": "student",
        "From page": getFromPage() || "Direct URL entered"
      }, {
        send_mixpanel: true
      });
    }
    trackAnalyticsEvent('Viewed QR Code Screen', {
      'Intent for': 'login',
      'Screen type': 'page',
      'From Page': 'signin'
    }, true);
  }, []);
  var sendInteractedEvent = function sendInteractedEvent() {
    var clickedOn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    trackEventsForGuests("Interacted QR Code Input Screen", {
      "mp_login_user_type": "student",
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
    trackEventsForGuests(hasCameraAccess ? 'Interacted QR code Input Screen Camera Access' : "Interacted QR code Input Screen No Camera Access", {
      "mp_login_user_type": "student",
      "Clicked on": clickedOn
    }, {
      send_mixpanel: true
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login",
    "data-sentry-component": "StudentQRCodeLogin",
    "data-sentry-source-file": "QRcodeLogin.tsx"
  }, !showQRPopup ? /*#__PURE__*/_react["default"].createElement("a", {
    className: "login-back",
    onClick: function onClick() {
      sendInteractedEvent("Back Button");
      window.location.hash = "#student";
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "iconcust-iconBackBtn"
  })) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-bg"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _studentLoginBg["default"]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "student-login-body qr-code"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Scan the QR code"), /*#__PURE__*/_react["default"].createElement(_QRcodeInput.QRcodeInput, {
    setHasCameraAccess: setHasCameraAccess,
    "data-sentry-element": "QRcodeInput",
    "data-sentry-source-file": "QRcodeLogin.tsx"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Login via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "#student-klasscode?fromPage=QR code scan input screen",
    onClick: function onClick() {
      return sendInteractedEvent("Login via class code");
    }
  }, "Class code")), /*#__PURE__*/_react["default"].createElement("img", {
    src: _teacherQrcodeHelp["default"],
    alt: "Don\u2019t have your QR code? Ask your teacher for help."
  })));
};
exports.StudentQRCodeLogin = StudentQRCodeLogin;